import { createGlobalState } from 'react-hooks-global-state';
import dayjs from 'dayjs';

export const { GlobalStateProvider, useGlobalState } = createGlobalState({
  userImage: '',
  IDImage: '',
  userFilePreview: [],
  IdFilePreview: [],
  termsApproval1: false,
  termsApproval2: false,
  formState: {
    first_name: '',
    last_name: '',
    email: '',
    contact: '',
    address_1: '',
    address_2: '',
    city: '',
    postcode: '',
    custom_field: '',
    country: '',
    date_of_birth: '',
    membership_plan_id: '',
    waitlist: false,
    vehicle_registration_no: '',
  },
});
